/* LEDBÁZIS – BASED-stílusú navigáció (asztali mega menü + mobil accordion).
   Függőség nélküli; eseménydelegálással működik, így a Horizon fejléc-frissítései
   (újrarenderelés, hidratálás) után sem veszíti el a működését. */
(function () {
  'use strict';
  if (window.__lbnLoaded) return;
  window.__lbnLoaded = true;

  var DESKTOP_MIN = 1100; /* ez alatt (750 px-től) a teljes képernyős menü él; ütközés esetén feljebb tolódik */
  var doc = document;

  function $(sel, ctx) {
    return (ctx || doc).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel));
  }
  function header() {
    return doc.getElementById('header-component') || $('header-component');
  }
  function setInert(el, on) {
    if (!el) return;
    el.inert = on;
    if (on) el.setAttribute('inert', '');
    else el.removeAttribute('inert');
  }

  /* ================================================================== */
  /* Asztali mega menü                                                   */
  /* ================================================================== */
  var closeTimer = null;
  var suppressFocusOpen = false;

  function deskRoot() {
    return $('[data-lbn]');
  }
  function isContained(el) {
    var c = el ? getComputedStyle(el).contain || '' : '';
    return /layout|paint|strict|content/.test(c);
  }
  function placeMega(root) {
    var hc = header();
    if (!hc || !root) return;
    var rect = hc.getBoundingClientRect();
    root.style.setProperty('--lbn-top', (isContained(hc) ? hc.offsetHeight : rect.bottom) + 'px');
    root.style.setProperty('--lbn-top-px', Math.max(0, rect.bottom) + 'px');
  }
  function deskOpen(id) {
    var root = deskRoot();
    if (!root) return;
    clearTimeout(closeTimer);
    var panel = $('[data-lbn-panel="' + id + '"]', root);
    if (!panel) return;
    if (!root.classList.contains('is-open')) placeMega(root);
    root.setAttribute('data-active', id);
    $$('[data-lbn-panel]', root).forEach(function (p) {
      p.classList.toggle('is-active', p === panel);
    });
    $$('.lbn__tab', root).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-lbn-tab') === id);
    });
    $$('.lbn__toplink[data-lbn-open]', root).forEach(function (t) {
      t.setAttribute('aria-expanded', t.getAttribute('data-lbn-open') === id ? 'true' : 'false');
    });
    setInert($('[data-lbn-mega]', root), false);
    root.classList.add('is-open');
  }
  function deskClose() {
    var root = deskRoot();
    clearTimeout(closeTimer);
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    setInert($('[data-lbn-mega]', root), true);
    $$('.lbn__toplink[data-lbn-open]', root).forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }
  function deskIsOpen() {
    var root = deskRoot();
    return !!(root && root.classList.contains('is-open'));
  }

  /* Egér: a BASED-hez hasonlóan rámutatásra nyit, a fejléc elhagyásakor zár */
  doc.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = deskRoot();
    if (!root) return;
    var opener = t.closest('[data-lbn-open]');
    if (opener && root.contains(opener)) {
      deskOpen(opener.getAttribute('data-lbn-open'));
      return;
    }
    if (!deskIsOpen()) return;
    if (t.closest('.lbn__toplink[data-lbn-close]')) {
      deskClose();
      return;
    }
    var hc = header();
    if (root.contains(t) && !t.closest('[data-lbn-scrim]')) {
      clearTimeout(closeTimer);
      return;
    }
    if (hc && hc.contains(t) && !root.contains(t)) {
      clearTimeout(closeTimer);
      /* a fejléc többi interaktív eleme (logó, ikonok, keresés) fölött bezár */
      if (t.closest('a, button, input, header-actions, .header-logo, .search-action')) deskClose();
      return;
    }
    clearTimeout(closeTimer);
    closeTimer = setTimeout(deskClose, 140);
  });

  /* Billentyűzet: fókuszra nyit, Esc zár, nyíl lefelé a panelre lép */
  doc.addEventListener('focusin', function (e) {
    var root = deskRoot();
    if (!root) return;
    var t = e.target;
    var opener = t.closest && t.closest('[data-lbn-open]');
    if (opener && root.contains(opener)) {
      if (suppressFocusOpen) return;
      deskOpen(opener.getAttribute('data-lbn-open'));
    } else if (t.closest && t.closest('.lbn__toplink[data-lbn-close]')) {
      deskClose();
    } else if (deskIsOpen() && !root.contains(t)) {
      deskClose();
    }
  });

  doc.addEventListener('keydown', function (e) {
    var root = deskRoot();
    if (!root || !deskIsOpen()) return;
    if (e.key === 'Escape') {
      var id = root.getAttribute('data-active');
      var trigger = $('.lbn__toplink[data-lbn-open="' + id + '"]', root);
      deskClose();
      if (trigger && root.contains(doc.activeElement)) {
        suppressFocusOpen = true;
        trigger.focus();
        suppressFocusOpen = false;
      }
    } else if (e.key === 'ArrowDown' && doc.activeElement && doc.activeElement.matches('.lbn__toplink[data-lbn-open]')) {
      e.preventDefault();
      var first = $('.lbn__panel.is-active a[href]', root);
      if (first) first.focus();
    }
  });

  doc.addEventListener('pointerdown', function (e) {
    var root = deskRoot();
    if (root && deskIsOpen() && (!root.contains(e.target) || (e.target.closest && e.target.closest('[data-lbn-scrim]')))) deskClose();
  });

  /* ================================================================== */
  /* Mobil teljes képernyős menü                                         */
  /* ================================================================== */
  var lowerTimer = null;

  function burger() {
    return $('[data-lbn-burger]');
  }
  /* A menü a <body>-ba kerül (a fejléc layout-containmentje miatt), és mindig csak egy példány marad. */
  function mnav() {
    var b = burger();
    var id = b && b.getAttribute('aria-controls');
    var all = $$('.lbn-mnav');
    if (id) {
      all = all.filter(function (n) {
        return n.id === id;
      });
    }
    if (!all.length) return null;
    var inBody = all.filter(function (n) {
      return n.parentElement === doc.body;
    });
    var keep = inBody[0] || all[0];
    all.forEach(function (n) {
      if (n !== keep) n.remove();
    });
    if (keep.parentElement !== doc.body) doc.body.appendChild(keep);
    return keep;
  }
  function mIsOpen() {
    return doc.body.classList.contains('lbn-mnav-open');
  }
  function setAcc(acc, open) {
    var t = $('[data-acc-toggle]', acc);
    acc.classList.toggle('is-open', open);
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    setInert($('.lbn-mnav__panel', acc), !open);
  }
  function headerSection() {
    var hc = header();
    return hc ? hc.closest('.shopify-section') || hc.parentElement : null;
  }
  function placeNav(nav) {
    var hc = header();
    if (!hc || !nav) return;
    nav.style.setProperty('--lbn-mtop', Math.max(0, Math.round(hc.getBoundingClientRect().bottom)) + 'px');
  }
  function mOpen() {
    var nav = mnav();
    var b = burger();
    if (!nav || !b) return;
    clearTimeout(lowerTimer);
    deskClose();
    placeNav(nav);
    $$('[data-acc]', nav).forEach(function (a) {
      setAcc(a, false);
    });
    nav.scrollTop = 0;
    var sec = headerSection();
    if (sec) sec.classList.add('lbn-header-raised');
    doc.body.classList.add('lbn-mnav-open');
    setInert(nav, false);
    nav.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    b.setAttribute('aria-label', b.getAttribute('data-label-close') || 'Menü bezárása');
  }
  function mClose(returnFocus) {
    var nav = mnav();
    var b = burger();
    if (!mIsOpen()) return;
    var hadFocus = nav && nav.contains(doc.activeElement);
    doc.body.classList.remove('lbn-mnav-open');
    if (nav) {
      nav.classList.remove('is-open');
      setInert(nav, true);
    }
    if (b) {
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-label', b.getAttribute('data-label-open') || 'Menü megnyitása');
    }
    lowerTimer = setTimeout(function () {
      var sec = headerSection();
      if (sec && !mIsOpen()) sec.classList.remove('lbn-header-raised');
    }, 420);
    if (returnFocus !== false && hadFocus && b) b.focus();
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-lbn-burger]')) {
      e.preventDefault();
      if (mIsOpen()) mClose();
      else mOpen();
      return;
    }
    var nav = t.closest('.lbn-mnav');
    if (!nav) return;
    var toggle = t.closest('[data-acc-toggle]');
    if (toggle) {
      var acc = toggle.closest('[data-acc]');
      var was = acc.classList.contains('is-open');
      $$('[data-acc]', nav).forEach(function (a) {
        setAcc(a, false);
      });
      if (!was) {
        setAcc(acc, true);
        var top = parseInt(nav.style.getPropertyValue('--lbn-mtop'), 10) || 0;
        var r = toggle.getBoundingClientRect();
        if (r.top < top) nav.scrollTop += r.top - top - 8;
      }
      return;
    }
    if (t.closest('a[href]')) mClose(false); /* a navigáció folytatódik */
  });

  doc.addEventListener('keydown', function (e) {
    if (!mIsOpen()) return;
    var nav = mnav();
    var b = burger();
    if (e.key === 'Escape') {
      e.preventDefault();
      mClose();
      return;
    }
    if (e.key !== 'Tab' || !nav) return;
    var items = [b].concat(
      $$('a[href], button:not([disabled])', nav).filter(function (el) {
        return !el.closest('[inert]') && el.getClientRects().length > 0;
      })
    ).filter(Boolean);
    if (!items.length) return;
    var idx = items.indexOf(doc.activeElement);
    if (e.shiftKey && idx <= 0) {
      e.preventDefault();
      items[items.length - 1].focus();
    } else if (!e.shiftKey && (idx === -1 || idx === items.length - 1)) {
      e.preventDefault();
      items[0].focus();
    }
  });

  /* ================================================================== */
  /* Reszponzív viselkedés                                               */
  /* ================================================================== */
  var forced = false;
  function overlaps(hc) {
    var links = $$('.lbn__toplink', hc);
    if (!links.length) return false;
    var last = links[links.length - 1].getBoundingClientRect();
    if (!last.width) return false;
    var right = $$('header-actions, .search-action', hc)
      .map(function (el) {
        return el.getBoundingClientRect();
      })
      .filter(function (r) {
        return r.width > 0 && r.left > last.left;
      })
      .map(function (r) {
        return r.left;
      });
    return right.length ? last.right > Math.min.apply(null, right) - 16 : false;
  }
  function applyMenuStyle() {
    var hc = header();
    if (!hc || !deskRoot()) return;
    var w = window.innerWidth;
    if (w >= 750 && w < DESKTOP_MIN) {
      if (hc.dataset.menuStyle !== 'drawer') {
        hc.dataset.menuStyle = 'drawer';
        forced = true;
      }
    } else if (w >= DESKTOP_MIN && hc.dataset.menuStyle === 'menu' && overlaps(hc)) {
      /* a főmenüpontok nem férnek el a logó és az ikonok között: mobilmenü */
      DESKTOP_MIN = w + 1;
      hc.dataset.menuStyle = 'drawer';
      forced = true;
    } else if (forced && w >= DESKTOP_MIN) {
      forced = false;
      import('@theme/utilities')
        .then(function (m) {
          if (m && m.setHeaderMenuStyle) m.setHeaderMenuStyle();
        })
        .catch(function () {
          hc.dataset.menuStyle = 'menu';
        });
    }
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      applyMenuStyle();
      if (deskIsOpen()) placeMega(deskRoot());
      if (mIsOpen()) {
        var b = burger();
        if (!b || b.getClientRects().length === 0) mClose(false);
        else placeNav(mnav());
      }
    }, 60);
  });

  window.addEventListener('pageshow', function () {
    deskClose();
    mClose(false);
  });

  function init() {
    mnav(); /* a mobilmenü áthelyezése a <body>-ba */
    applyMenuStyle();
    var hc = header();
    if (hc && !hc.__lbnObserved && window.MutationObserver) {
      hc.__lbnObserved = true;
      new MutationObserver(function () {
        var w = window.innerWidth;
        if (w >= 750 && (w < DESKTOP_MIN || hc.dataset.menuStyle === 'menu')) applyMenuStyle();
      }).observe(hc, { attributes: true, attributeFilter: ['data-menu-style'] });
    }
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () {
    mnav();
  });
  doc.addEventListener('shopify:section:load', init);
})();
